<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <div style="border-bottom: 1px solid rgb(222, 222, 222)">{{ dialogTitle }}</div>
      <div class="flex h-600px" style="margin-top: 10px">
        <el-form
          class="flex-1 w-900px"
          :class="{ 'w-full': dialogTitle !== '审批' }"
          ref="form"
          :model="form"
          label-width="100px"
          :rules="rules"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="标准名称" prop="standardId">
                <el-select
                  v-model="form.standardId"
                  clearable
                  filterable
                  placeholder="请选择"
                  size="small"
                  :disabled="true"
                  @change="changeStandardId"
                >
                  <el-option
                    v-for="item in standardIdList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="实体名称" prop="classId">
                <el-select
                  v-model="form.classId"
                  clearable
                  filterable
                  placeholder="请选择"
                  size="small"
                  :disabled="true"
                  @change="changeClassId"
                >
                  <el-option
                    v-for="item in classList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table
            v-loading="attrLoading"
            border
            :data="attributeData"
            :highlight-current-row="true"
            height="600px"
            ref="attributeTable"
            @selection-change="selectAttr"
            row-key="id"
          >
            <el-table-column
              v-if="tableHeader.length"
              fixed
              :reserve-selection="true"
              type="selection"
              width="40"
            ></el-table-column>
            <el-table-column label="序号" width="60" v-if="tableHeader.length">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
              </template>
            </el-table-column>
            <el-table-column
              v-for="(val, index) in tableHeader"
              :prop="`${val.tableName}.${val.columnName}`"
              show-overflow-tooltip
              :key="index"
              :label="val.name"
              min-width="150"
            >
              <template slot-scope="scope">
                <div class="truncate">
                  {{ scope.row[`${val.tableName}.${val.columnName}`] }}
                  <span v-if="val.unit && scope.row[`${val.tableName}.${val.columnName}`]">{{
                    val.unit
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableHeader.length"
              label="数据修改内容"
              prop="update_json"
              min-width="200"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
          <div class="mt-20px footer">
            <div>
              <el-button
                style="height: 32px; line-height: 32px; background-color: #0082ff; color: #fff"
                size="small"
                @click="handleBack"
                >返回</el-button
              >
            </div>
            <el-pagination
              background
              @current-change="attrCurrentChange"
              @size-change="attrSizeChange"
              :current-page.sync="attrPage.pageNo"
              :page-size="attrPage.pageSize"
              :page-sizes="$pageSizeAll"
              layout="->, total, sizes, prev, pager, next, jumper"
              :total="attrPage.total"
            ></el-pagination>
          </div>
        </el-form>
        <div
          v-if="_.includes(['审批', '查看'], dialogTitle)"
          class="!w-400px h-full ml-10px bg-[#f5f7fa] p-10px"
        >
          <div class="!w-400px h-full" :class="{ 'h-[calc(100%-148px)]': dialogTitle === '审批' }">
            <approvalProcess class="h-full" :processForm="processForm" />
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import dataRuleSettingService from '@/services/DataRuleSettingService'
import StandardManagementService from '@/services/common/StandardManagementService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import addAttributeData from './addAttributeData'
import approvalProcess from './approvalProcess'

export default {
  name: 'approval',
  components: { addAttributeData, approvalProcess },
  data() {
    return {
      rowData: {},
      checkStatus: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: '',
      form: {
        standardId: '',
        classId: '',
        opinion: '',
        id: '',
      },
      rules: {
        standardId: [{ required: true, message: '请选择标准名称', trigger: 'blur' }],
        classId: [{ required: true, message: '请选择实体名称', trigger: 'blur' }],
      },
      standardIdList: [],
      classList: [],
      attributeData: [],
      attrPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      selectAttrList: [],
      tableHeader: [],
      idList: [],
      attrLoading: false,
      processForm: {
        flowId: '',
        flowTaskId: '',
        visible: '',
      },
      checkLoading: false,
      type: '',
    }
  },
  // computed: {
  //   row() {
  //     return this.$route.query.row
  //   },
  // },
  async mounted() {
    const res = await dataRuleSettingService.getRecordId(this.$route.query.id)
    if (res.code == 0) {
      this.form.standardId = res.data.standardId
      this.form.classId = res.data.classId
      this.form.id = this.$route.query.id
      this.processForm.flowId = res.data.flowId
      this.processForm.flowTaskId = res.data.flowTaskId
      this.handleTanble(res.data)
    } else {
      this.$message.error('网络出错了')
    }
  },
  methods: {
    handleBack() {
      this.$router.go(-1)
    },
    // 处理工作
    handleWork() {
      if (this.checkStatus === 1) {
        this.passData()
      } else {
        this.rejectData()
      }
    },
    // 驳回
    async rejectData() {
      this.checkLoading = true
      const res = await dataRuleSettingService.passedOrRejected({
        id: this.form.id,
        opinion: this.form.opinion,
        isPass: false,
      })
      this.checkLoading = false
      if (res && res.code === 0) {
        this.$message.success('审批驳回')
        this.closeDialog()
      }
      this.$router.go(-1)
    },
    // 通过
    async passData() {
      this.checkLoading = true
      const res = await dataRuleSettingService.passedOrRejected({
        id: this.form.id,
        opinion: this.form.opinion,
        isPass: true,
      })
      this.checkLoading = false
      if (res && res.code === 0) {
        this.$message.success('审批通过')
        this.closeDialog()
      }
      this.$router.go(-1)
    },
    async handleTanble(row) {
      if (localStorage.getItem('standardList')) {
        this.standardIdList = JSON.parse(localStorage.getItem('standardList'))
      } else {
        this.standardIdList = await this.getStandardList()
      }
      this.dialogTitle = '查看'
      this.processForm.flowTaskId = row.flowTaskId
      this.processForm.flowId = row.flowId
      this.processForm.visible = true
      _.assign(this.form, _.pick(row, ['id', 'standardId', 'classId']))
      this.getClassList()
      this.getDynamicTableHeader()
      this.getIdsByApprovalRecordId()
    },
    closeDialog() {
      this.checkStatus = ''
      this.form.opinion = null
      this.processForm.visible = false
    },
    // 获取标准库
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        return res.data
      }
      return []
    },
    // 建立审批策略的实体
    async getClassList() {
      const res = await dataRuleSettingService.getApprovalStategyEntity(this.form.standardId)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
      }
    },
    changeStandardId(val) {
      this.form.classId = ''
      if (val) {
        this.getClassList()
      } else {
        this.classList = []
      }
    },
    attrCurrentChange(num) {
      this.attrPage.pageNo = num
      this.searchAttrData()
    },
    attrSizeChange(size) {
      this.attrPage.pageSize = size
      this.searchAttrData()
    },
    selectAttr(val) {
      this.selectAttrList = val
    },
    changeClassId(id) {
      if (id) {
        this.getDynamicTableHeader()
      }
    },
    // 获取实体数据管理动态表头
    async getDynamicTableHeader() {
      const res = await stdClassDataService.getDynamicTableHeader({
        classId: this.form.classId,
      })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
      }
    },
    // 根据审批记录id获取数据id集合
    async getIdsByApprovalRecordId() {
      const res = await dataRuleSettingService.getIdsByApprovalRecordId(this.form.id)
      if (res && res.code === 0 && res.data) {
        this.idList = res.data
        this.searchAttrData()
      }
    },
    // 根据数据id获取动态表数据
    async searchAttrData() {
      this.attrLoading = true
      const res = await stdClassDataService.getDynamicTableData({
        classId: this.form.classId,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        ids: this.idList,
        showUpdateData: true,
      })
      this.attrLoading = false
      if (res && res.code === 0 && res.data) {
        this.attributeData = res.data
        this.attrPage.total = res.totalCount
      } else {
        this.attributeData = []
        this.attrPage.total = 0
      }
    },
  },
}
</script>

<style lang="scss" scope>

.footer {
  display: flex;
  justify-content: flex-end;
  justify-content: center;
  align-content: center;
}

</style>
